import { VStack, Text, Wrap, Divider, HStack } from '@chakra-ui/react';
import React from 'react';
import { SingleObject } from '../../../types/ObjectTypes';
import { Box } from '@chakra-ui/layout';
import { ImageGallery } from '../../common/ImageGallery/ImageGallery';
import { BookingRange } from '../BookingRange';
import { BookingParams } from '../../../types/BookingTypes';
import { Number } from '../../common/Format/Number';
import { PriceAccordion } from './PriceAccordion/PriceAccordion';

export interface BookingObjectProps {
  object: SingleObject;
  bookingParams: BookingParams;
}
export const ObjectOverview = (props: BookingObjectProps): JSX.Element => {
  const { object, bookingParams } = props;
  const { baseData, imagesData, priceData } = object;

  return (
    <VStack
      p={4}
      borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
      borderWidth={1}
      borderColor={'gray.300'}
      backgroundColor={'white'}
      w={'100%'}
      alignItems={'flex-start'}
      gridGap={4}>
      <Wrap spacing={0} lineHeight={1.2}>
        <Text fontWeight={'semibold'} w={'100%'} textAlign={'left'} fontSize={'xl'}>
          {baseData.Name}
        </Text>
        <Text>
          {baseData.Region}, {baseData.City}
        </Text>
      </Wrap>

      <VStack gridGap={0} w={'100%'} flex={1}>
        <Box w={'100%'} h={{ base: 350, xl: 200 }}>
          <ImageGallery images={imagesData} showMore={false} />
        </Box>
      </VStack>

      <BookingRange bookingParams={bookingParams} />

      {(priceData && !baseData.DisableOnlinePriceCalculation) && (
        <VStack width={'100%'} gridGap={2}>
          {priceData.RENTAL && (
            <PriceAccordion
              title={priceData.RENTAL.numberOfDays + ' ' + 'Übernachtungen'}
              objectSalesType={priceData.RENTAL}
            />
          )}

          {priceData.SERVICE && priceData.SERVICE.additionalInfo.length > 0 && (
            <PriceAccordion title={'Zusatzleistungen'} objectSalesType={priceData.SERVICE} />
          )}
          {priceData.FINAL_CLEANING && priceData.FINAL_CLEANING.additionalInfo.length > 0 && (
            <PriceAccordion title={'Endreiningung'} objectSalesType={priceData.FINAL_CLEANING} />
          )}

          {priceData.PET && priceData.PET.additionalInfo.length > 0 && (
            <HStack alignItems={'flex-start'} width={'100%'}>
              <Text flex={1}>Haustiere</Text>
              <Text alignSelf={'flex-end'}>
                <Number
                  number={priceData.PET.totalPrice}
                  locales={'de-De'}
                  style={'currency'}
                  currency={'EUR'}
                />
              </Text>
            </HStack>
          )}
          <Divider />
          {priceData.TOURIST_TAX && priceData.TOURIST_TAX.additionalInfo.length > 0 && (
            <HStack alignItems={'flex-start'} width={'100%'}>
              <Text flex={1}>Kurtaxe</Text>
              <Text alignSelf={'flex-end'} fontWeight={'semibold'}>
                <Number
                  number={priceData.TOURIST_TAX.totalPrice}
                  locales={'de-De'}
                  style={'currency'}
                  currency={'EUR'}
                />
              </Text>
            </HStack>
          )}

          <HStack alignItems={'flex-start'} width={'100%'} pt={4}>
            <Text flex={1}>Ihr Gesamtpreis</Text>
            <Text alignSelf={'flex-end'} fontWeight={'semibold'}>
              <Number
                number={priceData.COMMON.totalPrice}
                locales={'de-De'}
                style={'currency'}
                currency={'EUR'}
              />
            </Text>
          </HStack>

          {priceData.DEPOSIT && priceData.DEPOSIT.additionalInfo.length > 0 && (
            <HStack alignItems={'flex-start'} width={'100%'}>
              <Text flex={1}>Kaution</Text>
              <Text alignSelf={'flex-end'} fontWeight={'semibold'}>
                <Number
                  number={priceData.DEPOSIT.totalPrice}
                  locales={'de-De'}
                  style={'currency'}
                  currency={'EUR'}
                />
              </Text>
            </HStack>
          )}
        </VStack>
      )}
    </VStack>
  );
};
